/**
 * Relay leg label helpers for heat sheet PDF rendering.
 *
 * Rules:
 *   - "Medley Relay"         → stroke abbreviation per position: 1=BK, 2=BR, 3=FL, 4=FR
 *   - All other relay types  → leg number (1, 2, 3, 4)
 */

const MEDLEY_LEG_LABELS = { 1: "BK", 2: "BR", 3: "FL", 4: "FR" }

/**
 * Returns the label prefix for a single relay leg swimmer.
 *
 * @param {string} stroke      - long_name from strokeMapping (e.g. "Medley Relay", "Freestyle Relay")
 * @param {number} legPosition - 1-based leg position derived from swimmerOrder (or array index fallback)
 * @returns {string}           - e.g. "BK", "1"
 */
export function getRelayLegLabel(stroke, legPosition) {
  if (stroke === "Medley Relay") {
    return MEDLEY_LEG_LABELS[legPosition] || String(legPosition)
  }
  return String(legPosition)
}
